module.exports = __webpack_public_path__ + "static/media/Front Left Tire.60775761.svg";